import React from "react";
import Reveal from "./Reveal";

const STEPS = [
  {
    num: "01",
    title: "Tell Us What Happened",
    desc: "Share your story through our secure form. It takes less than two minutes — no commitment, no fees.",
  },
  {
    num: "02",
    title: "Speak With Our Team",
    desc: "We review your case immediately and reach out personally to discuss your options and next steps.",
  },
  {
    num: "03",
    title: "We Fight For You",
    desc: "We handle insurance companies, paperwork, and negotiations — so you can focus entirely on healing.",
  },
];

export default function Process() {
  return (
    <section
      data-testid="process-section"
      className="relative bg-[#091A33] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <Reveal className="text-center max-w-2xl mx-auto mb-16 md:mb-20">
          <div className="flex items-center justify-center gap-3 mb-5">
            <div className="h-px w-10 bg-[#B89968]" />
            <span className="text-[#B89968] text-xs uppercase tracking-[0.32em]">
              How It Works
            </span>
            <div className="h-px w-10 bg-[#B89968]" />
          </div>
          <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-white leading-tight">
            Three simple steps. <span className="italic gold-text">One trusted team.</span>
          </h2>
        </Reveal>

        <div className="relative grid md:grid-cols-3 gap-8 md:gap-0">
          {/* Connector line on desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-px bg-gradient-to-r from-transparent via-[#B89968]/40 to-transparent" />

          {STEPS.map((s, i) => (
            <Reveal
              key={s.num}
              delay={i * 120}
              className="relative md:px-6 text-center md:text-left"
              data-testid={`process-step-${i}`}
            >
              <div className="relative inline-flex md:flex items-center justify-center mb-6">
                <div className="w-24 h-24 border border-[#B89968]/40 bg-[#0F2240] flex items-center justify-center font-serif-display text-3xl text-[#B89968]">
                  {s.num}
                </div>
              </div>
              <h3 className="font-serif-display text-2xl text-white mb-3">
                {s.title}
              </h3>
              <p className="text-[#94A3B8] leading-relaxed max-w-xs mx-auto md:mx-0">
                {s.desc}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
